import {  apiCalls } from "./apiCalls";
import config from "../config";
export const getBlogs = async () => {
    const url = config.base_url_4 + "/api/v1/common/blog_details";
   //const url = "http://127.0.0.1:3010/blog_details"
   let reqObject = {}
    try {
      const result = await apiCalls("post", url, reqObject);
      return result.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.err);
      } else {
        console.error("getBlogs, server err:", error.message);
        throw new Error(error.message);
      }
    }
  };

//   export const getBlogDetails = async () => {
//     // const url = config.base_url_4 + "/api/v1/assets/all_dreams_mapped_asset_list";
//     const url = "http://127.0.0.1:3010/blog_details"
//     let reqObject = {}
//      try {
//        const result = await apiCalls("get", url, reqObject);
//        return result.data;
//      } catch (error) {
//        if (error.response) {
//          throw new Error(error.response.data.err);
//        } else {
//          console.error("getBlogs, server err:", error.message);
//          throw new Error(error.message);
//        }
//      }
//    };